import { useTranslation } from "next-i18next";
import { vehicleValidation } from "@talladega/helpers";
import { FieldValues } from "react-hook-form";
import { FormInputProps } from "@talladega/types";
import { Form } from ".";

type Props<T extends FieldValues> = {
  required?: boolean;
} & FormInputProps<T>;

export const TrimInput = <TFormValues extends FieldValues>({
  name,
  register,
  errors,
  required = false,
  ...props
}: Props<TFormValues>): JSX.Element => {
  const { t } = useTranslation(["common"]);

  const error = name ? errors?.[name] : undefined;

  return (
    <Form.Input
      id="trim"
      label={t("common:trim") || undefined}
      feedback={error?.message?.toString()}
      status={error ? "error" : "default"}
      maxLength={vehicleValidation.trim.maxLength}
      {...(register &&
        name &&
        register(name, {
          required: {
            value: required,
            message: t("common:required"),
          },
          maxLength: {
            value: vehicleValidation.trim.maxLength,
            message: t("common:invalid_trim"),
          },
        }))}
      {...props}
    />
  );
};

export default {};
